import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from '@emotion/styled';
import { Field } from 'formik';
import FieldContainer from './Misc/FieldContainer';
import getLangData from '../../utils/getLangData';

const SearchableSelect = props => {
  const {
    getItems,
    options,
    name: fieldName,
    isLoading,
    disabled,
    label,
    isMulti,
    getLabel,
    optionLabel,
    value,
    wide,
    placeholder,
  } = props;

  const [searchValue, setSearchValue] = useState('');
  const defaultLabel = getLabel ? getLabel : 'name';
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {

    let timeID = setTimeout(() => {
      if (getItems)
        getItems({ searchTerm: searchValue, size: 50 });
    }, 500)
    return () => clearTimeout(timeID)
  }, [getItems, searchValue]);



  return (
    <Field name={fieldName}>
      {({ form, field, meta }) => {


        return (
          <div className='form-group'>
            {/* <label className="col-lg-3 col-form-label" htmlFor={fieldName}> */}
            <label htmlFor={fieldName}>{label} :</label>
            <FieldContainer errorMessage={meta.error}>
              <Select
                {...field}
                isLoading={isLoading}
                isMulti={isMulti}
                isDisabled={disabled}
                onChange={changedValue => {
                  if (changedValue === null && isMulti) {
                    form.setFieldValue(field.name, []);
                    return;
                  }

                  if (isMulti) {
                    form.setFieldValue(field.name, changedValue);
                  }

                  // single
                  if (!isMulti) {
                    form.setFieldValue(fieldName, changedValue);
                  }
                }}
                inputValue={searchValue}
                // defaultInputValue={{_id: defaultValues}}
                placeholder={
                  placeholder ? placeholder : getLangData().search.title
                }
                options={options}
                styles={{
                  menu: (provided, state) => ({
                    ...provided,
                    zIndex: 999,
                    width: '100%'
                  })
                }}
                // value={
                //   // Update
                //   // on Create

                //   field.value &&
                //   options.filter((option) =>
                //     isMulti
                //       ? field.value.indexOf(option.id) > -1
                //       : option.id === field.value

                //   )
                // }
                getOptionLabel={option => option.name}
                getOptionValue={option => option._id}
                onInputChange={inputValue => {
                  setSearchValue(inputValue);
                  return inputValue;
                }}
                onFocus={() => {
                  form.setFieldTouched(fieldName, true);
                }}
                onBlur={() => {
                  if (!field.value) {
                    // form.setFieldError(fieldName, getLangData().fields.required);
                  }
                }}
                getOptionLabel={
                  optionLabel ? optionLabel : option => option[defaultLabel]
                }
                getOptionValue={option => option._id}
                value={field.value}
              />
            </FieldContainer>
          </div>
        );
      }}
    </Field>
  );
};

// const FieldContainer = styled.div`
//   position: relative;
//   padding-bottom: '15px';
//   width: 100%
// `;

export default SearchableSelect;
